function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './InteractiveMapModal.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../../utils/analytics';
import { get, getPageThemeColors, getColorByTheme, canUseDOM, getDictionaryItem } from '../../../utils';
import InteractiveGoogleMap from '../../atoms/InteractiveMap/InteractiveGoogleMap';
import InteractiveMapListing from '../../atoms/InteractiveMap/InteractiveMapListing';
import InteractiveMapLayout from '../../atoms/InteractiveMap/InteractiveMapLayout';
import { getTopPicksStorage } from '../../atoms/FavouriteBtn/top_picks_apis';
import { idConverter } from '../atoms/../FavouriteBtn/FavouriteBtn';
import Modal from '../../atoms/Modal/Modal';
import { useModal } from '../../atoms/Modal/useModal';
import { removeBodyOverflow } from '../InteractiveMap/utils/toggleLeftPanelOverflow';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const InteractiveMapModal = _ref => {
  let {
    loading,
    params,
    hits,
    mainHitsPerPage = '10',
    mainTitle,
    contentType,
    defaultMapZoom = 10,
    centreMapLatitude = 25.2048493,
    centreMapLongitude = 55.2707828,
    dictionary,
    eventsAnalytics,
    filtersComponent,
    mapModalColor
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const {
    isShown,
    toggle
  } = useModal();
  const [listingHits, setListingHits] = React.useState([...hits]);
  const [mapApiReady, setMapApiReady] = React.useState(false);
  const [mapState, setMapState] = React.useState({});
  const [isVdsite, setIsVdsite] = React.useState(true);
  const [mobileListingView, setMobileListingView] = React.useState(false);
  const [activeListingItemId, setActiveListingItemId] = React.useState(null);
  const [activePopupItem, setActivePopupItem] = React.useState(null);
  const [activeTopPicks, setActiveTopPicks] = React.useState([]);
  const defaultTypeValues = React.useRef([]);
  const noItemsInLisitng = getDictionaryItem(dictionary, 'noItemsInList') || '';
  const viewAsList = getDictionaryItem(dictionary, 'viewAsList') || '';
  const viewMoreAsList = getDictionaryItem(dictionary, 'viewMoreAsList') || '';
  const viewAsMap = getDictionaryItem(dictionary, 'viewOnMap') || '';
  const listingTitleSelected = getDictionaryItem(dictionary, 'findAndBook') || '';
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m113-interactive-map-background-color': BackgroundColorHex,
    '--m113-interactive-map-background-active-color': ActiveColorHex,
    '--m113-interactive-map-color': ColorHex
  } : {
    '--m113-interactive-map-background-color': selectedPrimaryColor,
    '--m113-interactive-map-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m113-interactive-map-color': getColorByTheme(selectedPrimaryColor)
  };
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  React.useEffect(() => {
    setListingHits(hits);
  }, [hits]);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    if (canUseDOM) {
      let topPicks = getTopPicksStorage();
      let topPicksList = topPicks.list || [];
      setActiveTopPicks(topPicksList.map(el => el.itemId));
    }
    return () => {
      setMapApiReady(false);
    };
  }, []);
  const updateLocation = () => {
    const defaultLat = Number(centreMapLatitude);
    const defaultLng = Number(centreMapLongitude);
    let markers = [];
    if (hits.length) {
      markers = hits.map(el => {
        el.color = mapModalColor;
        return el;
      });
    }
    setMapState({
      lat: defaultLat,
      lng: defaultLng,
      markers
    });
  };
  React.useEffect(() => {
    if (mapApiReady && !loading) {
      updateLocation();
    }
  }, [mapApiReady, loading, hits]);
  const handleGetHitsFromMap = mapItemsInViewPort => {
    const loadedItemsFromMap = mapItemsInViewPort.filter(el => el.data).map(el => el.data);
    setListingHits(loadedItemsFromMap.length ? loadedItemsFromMap : hits);
  };
  const handleGetActiveItemId = id => {
    setActiveListingItemId(id);
  };
  const apiReady = () => {
    setMapApiReady(true);
  };
  const getActivePopupOnMap = item => {
    setActivePopupItem(item);
  };
  const toggleActiveTopPicks = objectId => {
    const id = idConverter(objectId);
    let topPicks = getTopPicksStorage();
    let topPicksList = topPicks.list || [];
    let list = [...topPicksList.map(el => el.itemId)];
    if (list.includes(id)) {
      const index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    } else {
      list.push(id);
    }
    setActiveTopPicks(list);
  };
  const leftBar = /*#__PURE__*/React.createElement(React.Fragment, null, filtersComponent, /*#__PURE__*/React.createElement(InteractiveMapListing, {
    analytics: eventsAnalytics,
    params: params,
    listingItems: listingHits,
    hits: hits,
    defaultTypeValues: defaultTypeValues.current,
    rtl: rtl,
    noItemsDictionary: noItemsInLisitng,
    viewAsListingDictionary: viewAsList,
    viewMoreAsListingDictionary: viewMoreAsList,
    viewAsMapDictionary: viewAsMap,
    listingTitleCommonDictionary: '',
    withMapModalView: true,
    listingTitleSelectedDictionary: `${listingTitleSelected.replace('{restaurants}', `${mainTitle}`)}`,
    chosenTypes: [{
      nestedFilters: {
        values: []
      },
      searchIndex: '',
      value: contentType,
      title: mainTitle
    }],
    mainHitsPerPage: mainHitsPerPage,
    activeListingItemId: activeListingItemId,
    loading: loading,
    getActivePopupOnMap: getActivePopupOnMap,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: objectId => toggleActiveTopPicks(objectId),
    toggleMobileListingView: listingView => {
      setMobileListingView(listingView);
    },
    mapModalColor: mapModalColor
  }));
  const rightBar = /*#__PURE__*/React.createElement(InteractiveGoogleMap, {
    mapState: mapState,
    callback: apiReady,
    handleGetHitsFromMap: hits => handleGetHitsFromMap(hits),
    handleGetActiveItemId: id => handleGetActiveItemId(id),
    dictionary: dictionary,
    defaultMapZoom: defaultMapZoom,
    centreMapLatitude: centreMapLatitude,
    centreMapLongitude: centreMapLongitude,
    analytics: eventsAnalytics,
    params: params,
    rtl: rtl,
    activePopupItem: activePopupItem,
    activeTopPicks: activeTopPicks,
    toggleActiveTopPicks: objectId => toggleActiveTopPicks(objectId)
  });
  const handleToggleModal = () => {
    setMapApiReady(false);
    setActivePopupItem(null);
    setListingHits(hits);
    toggle();
    removeBodyOverflow();
  };
  const ToggleButton = props => /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: `interactive-map-modal__toggle ${!isShown ? 'viewAsMap' : 'viewAsList'}`,
    onClick: () => {
      // if (canUseDOM && !listingView) {
      //   window.scrollTo(0, 0);
      // }
      handleToggleModal();
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['viewMapButton'], params), `${!isShown ? viewAsMap : viewAsList}`);
    }
  }, props), isShown ? /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.992",
    height: "14",
    viewBox: "0 0 18.992 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15417",
    "data-name": "Group 15417",
    transform: "translate(-122.531 -775.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: "12",
    transform: "translate(128.523 776.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: "7",
    transform: "translate(128.523 782.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x2: "10",
    transform: "translate(128.523 788.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x1: "0.992",
    transform: "translate(123.531 776.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x1: "0.992",
    transform: "translate(123.531 782.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x1: "0.992",
    transform: "translate(123.531 788.5)",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }))) : /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14.27",
    height: "20.015",
    viewBox: "0 0 14.27 20.015"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: "14.27",
    height: "20.015",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265",
    "clip-path": "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M10.42,13.826a3.437,3.437,0,1,0-3.445-3.46,3.449,3.449,0,0,0,3.445,3.46m0-5.6a2.129,2.129,0,0,1,2.159,2.145,2.167,2.167,0,1,1-4.333,0A2.137,2.137,0,0,1,10.42,8.221",
    transform: "translate(-3.278 -3.266)",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M12.357,2.282A7.206,7.206,0,0,0,7.142,0a7.226,7.226,0,0,0-5.23,2.289,6.88,6.88,0,0,0-1.9,5.172A8.453,8.453,0,0,0,.17,8.625L.418,9.6a22.409,22.409,0,0,0,2.719,5.518,36.834,36.834,0,0,0,3.549,4.706.63.63,0,0,0,.456.193A.644.644,0,0,0,7.6,19.82a36.918,36.918,0,0,0,3.534-4.705c1.977-3.082,3-5.586,3.124-7.654a6.891,6.891,0,0,0-1.9-5.18M7.142,1.27a5.926,5.926,0,0,1,4.286,1.882,5.629,5.629,0,0,1,1.559,4.23c-.146,2.4-1.9,5.449-2.926,7.055A36.686,36.686,0,0,1,7.142,18.4a36.117,36.117,0,0,1-2.934-3.958c-1.03-1.607-2.78-4.659-2.926-7.055A5.622,5.622,0,0,1,2.841,3.16a5.946,5.946,0,0,1,4.3-1.89",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.2"
  }))), !isShown ? viewAsMap : viewAsList);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    style: variables
  }, /*#__PURE__*/React.createElement(ToggleButton, null), /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: handleToggleModal,
    fullPageCover: true,
    style: variables
  }, !mobileListingView ? /*#__PURE__*/React.createElement(ToggleButton, {
    id: "interactive-map-toggle"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(InteractiveMapLayout, {
    params: params,
    rtl: rtl,
    loading: loading,
    leftBar: leftBar,
    rightBar: rightBar,
    stylesVariables: variables,
    withMapModalView: true
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`,
    style: style
  }, children);
};
const commonStyles = "c19y9wdy";
const ltrStyles = "l17k8pbc";
const rtlStyles = "r1nntajn";
export default InteractiveMapModal;